import { COMPLIANCE_DOCUMENT_TYPES, ComplianceDocumentFormType } from 'domain/shared/compliance';

export const isInformationalDocument = (complianceType?: string) =>
  complianceType === COMPLIANCE_DOCUMENT_TYPES.informational_document;

export const isAllEmployeesAvailable = (complianceType?: string) =>
  complianceType === COMPLIANCE_DOCUMENT_TYPES.policy || isInformationalDocument(complianceType);

export const isAudienceFiltersVisible = (data?: ComplianceDocumentFormType) => {
  const hasAllEmployeesOption = isAllEmployeesAvailable(data?.complianceType);
  const isAllEmployeesSelected = hasAllEmployeesOption ? !!data?.isAllEmployee : false;

  return !isAllEmployeesSelected;
};
